import { useState, useRef } from 'react';
import { useOutsideMenuCloserWithFunction } from '../helpers';

export const useHeaderProfile = () => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const wrapperRefDropdown = useRef(null);
  
  useOutsideMenuCloserWithFunction(wrapperRefDropdown, () =>
    setIsProfileMenuOpen(false)
  );

  return {
    isProfileMenuOpen,
    setIsProfileMenuOpen,
    wrapperRefDropdown,
  };
};
